import React from 'react'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import styled from 'styled-components'
import { Tooltip } from '@mui/material'

const EditIcon = ({ onClick }) => {
  return (
    <Tooltip title='Edytuj'>
      <Content>
        <StyledIcon onClick={onClick} />
      </Content>
    </Tooltip>
  )
}

export default EditIcon

const StyledIcon = styled(EditOutlinedIcon)`
  cursor: pointer;
  font-size: 18px !important;
`

const Content = styled.div`
  display: flex;
  align-items: center;
`
